import { EUserLevel } from '../../../../store/general/types';

export const PlayListLevelTitles: Record<EUserLevel, string> = {
  [EUserLevel.UNKNOWN]: 'Undefined',
  [EUserLevel.BEGINNER]: 'Beginner',
  [EUserLevel.INTERMEDIATE]: 'Intermediate',
  [EUserLevel.ADVANCED]: 'Advanced'
}
